import * as Yup from 'yup';

export const TrackPackageSchema = Yup.object().shape({
  trackingId: Yup.string()
    .min(1)
    .required('Error! Please enter a valid package ID'),
});

export type TrackPackageDataType = Yup.InferType<typeof TrackPackageSchema>;

type InitialValues = {
  trackingId: string;
};

export const trackPackageInitialValues: InitialValues = {
  trackingId: '',
};

export interface IParcelItem {
  parcelId: string;
  itemName: string;
  weight: string;
}

export interface ITrackPackageResponse {
  packageId: string;
  paid: boolean;
  scheduledDeliveryDate: string;
  shippingStatus: string;
  deliveredDate?: string;
  deliveryAddress?: string;
  receiverName?: string;
  receivedOn?: string;
  parcels?: IParcelItem[];
  // proof of delivery fields
  signatureUrl?: string;
  address?: string;
  summary?: string;
  name?: string;
  weight?: number;
  id?: string;
}

export interface ITrackPackageDataRequest {
  trackingId: string;
}
